export function shallowCloneSchemaNode(node) {
    return { ...node };
}
